import React, { useState } from "react";
import * as Components from "../../../components/all";
import { useParams } from "react-router-dom";

import { MdOutlineLocalOffer, MdOutlinePriceChange } from "react-icons/md";
import { BsCalendar3, BsTextLeft } from "react-icons/bs";

export default function NewPackage() {
	const params = useParams();
	const [loading, setLoading] = useState(false);
	// Map
	const [showMap, setShowMap] = useState(false);

	// Styles
	var mainContainerStyles = `flex flex-col justify-center 
    flex-wrap sm:mx-20 md:mx-24`;
	var containerStyles = `h-fit w-full flex items-cente p-2 text-darker overflow-x-auto border rounded-md shadow-sm m-1`;
	var iconStyles = `h-6 aspect-square flex items-center justify-center text-dark borde mr-3`;
	var inputStyles = `flex-1 bg-transparent text-sm text-darker focus:outline-none`;

	// New Parking Space
	const [newPackage, setNewPackage] = useState({
		name: null,
		desc: null,
		days: null,
		price: null,
	});

	// Handle Create
	const handleCreate = () => {
		console.log(newPackage);
		for (var key in newPackage) {
			if (newPackage.hasOwnProperty(key) && newPackage[key] === null) {
				console.log("Found null value for property:", key);
			}
		}
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="NewParkingSpace
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="relative
					min-h-[450px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* Heading */}
					<div
						className="
							w-full
							p-2 pt-0 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<Components.BackButton />
							<h1 className="ml-2 text-darker">New Package Form</h1>
						</div>
					</div>

					{/* Package Info */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Package Information
							</h1>
						</div>

						{/* name */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<MdOutlineLocalOffer />
							</div>
							<input
								type="text"
								className={inputStyles}
								placeholder="Name"
								value={newPackage.name}
								onChange={(e) =>
									setNewPackage((prev) => ({ ...prev, name: e.target.value }))
								}
							/>
						</div>

						{/* description */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<BsTextLeft />
							</div>
							<input
								type="text"
								className={inputStyles}
								placeholder="Description"
								value={newPackage.desc}
								onChange={(e) =>
									setNewPackage((prev) => ({ ...prev, desc: e.target.value }))
								}
							/>
						</div>

						{/* days */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<BsCalendar3 />
							</div>
							<input
								type="number"
								className={inputStyles}
								placeholder="Days"
								value={newPackage.days}
								onChange={(e) =>
									setNewPackage((prev) => ({ ...prev, days: e.target.value }))
								}
							/>
						</div>

						{/* price */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<MdOutlinePriceChange />
							</div>
							<input
								type="number"
								className={inputStyles}
								placeholder="Price"
								value={newPackage.price}
								onChange={(e) =>
									setNewPackage((prev) => ({ ...prev, price: e.target.value }))
								}
							/>
						</div>
					</div>

					{/* Create Button */}
					<div className={mainContainerStyles}>
						<button
							className="bg-main text-white m-4 mt-12 px-8 py-1 rounded-md hover:opacity-70"
							onClick={() => handleCreate()}
						>
							Create
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
